import { FieldValues } from "react-hook-form";
import * as yup from "yup";

export const StoreSchema = yup.object({
    storeIdWasInvalid: yup.boolean().default(false)
});

export type StoreFormValues = yup.InferType<typeof StoreSchema> & FieldValues;
